(function () {
  "use strict";

  var INTENT_KEY = "theartfolio_follow_intent";
  var CACHE_KEY = "theartfolio_follow_state";
  var COUNT_MIN = 10;
  var listeners = [];
  var state = {};
  var pending = {};

  function theme() {
    return window.theme || {};
  }

  function proxyPath() {
    var path = theme().followProxyPath || "/apps/artfolio";
    return String(path).replace(/\/$/, "");
  }

  function isLoggedIn() {
    return Boolean(theme().customerId) || theme().loggedIn === true;
  }

  function loginUrl() {
    var base = theme().accountLoginUrl || "/account/login";
    var here = window.location.href.split("#")[0];
    var path = window.location.pathname + window.location.search;
    var sep = base.indexOf("?") >= 0 ? "&" : "?";
    return (
      base +
      sep +
      "return_to=" + encodeURIComponent(here) +
      "&return_url=" + encodeURIComponent(path)
    );
  }

  function readCache() {
    try {
      var parsed = JSON.parse(sessionStorage.getItem(CACHE_KEY) || "null");
      if (!parsed || typeof parsed !== "object") return {};
      return parsed.state && typeof parsed.state === "object" ? parsed.state : parsed;
    } catch (error) {
      return {};
    }
  }

  function writeCache() {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ state: state }));
    } catch (error) {}
  }

  function emit(slug, next) {
    listeners.forEach(function (fn) {
      try {
        fn(slug, next);
      } catch (error) {}
    });
    document.dispatchEvent(
      new CustomEvent("theartfolio:followchange", { detail: { slug: slug, state: next } })
    );
  }

  function formatCount(count) {
    var n = Number(count) || 0;
    if (n < COUNT_MIN) return "";
    return n === 1 ? "1 follower" : n + " followers";
  }

  function applyButton(btn, row) {
    var slug = (btn.getAttribute("data-follow-artist") || "").trim().toLowerCase();
    if (!slug) return;
    var current = state[slug] || { following: false, follower_count: 0, last_seen_at: null };
    var isPending = Boolean(pending[slug]);
    btn.setAttribute("aria-pressed", current.following ? "true" : "false");
    btn.setAttribute("aria-busy", isPending ? "true" : "false");
    btn.classList.toggle("is-error", Boolean(current.error));
    btn.disabled = isPending;
    var countEl = (row || btn.closest("[data-follow-row]") || btn.parentNode).querySelector("[data-follow-count]");
    if (countEl) {
      var label = formatCount(current.follower_count);
      countEl.textContent = label;
      if (label) countEl.removeAttribute("hidden");
      else countEl.setAttribute("hidden", "");
    }
  }

  function paint(slug) {
    document.querySelectorAll('[data-follow-artist="' + slug + '"]').forEach(function (btn) {
      applyButton(btn, btn.closest("[data-follow-row]"));
    });
  }

  function mergeState(partial) {
    Object.keys(partial || {}).forEach(function (slug) {
      var row = partial[slug] || {};
      state[slug] = {
        following: Boolean(row.following),
        follower_count: Number(row.follower_count) || 0,
        last_seen_at: row.last_seen_at || null,
        error: Boolean(row.error)
      };
    });
    writeCache();
  }

  function request(path, options) {
    return fetch(proxyPath() + path, Object.assign({
      credentials: "same-origin",
      headers: { accept: "application/json" }
    }, options || {})).then(function (res) {
      return res.json().catch(function () {
        return {};
      }).then(function (body) {
        body = body || {};
        body.status = res.status;
        body.ok = res.ok;
        return body;
      });
    });
  }

  function stashIntent(slug, action, source) {
    try {
      sessionStorage.setItem(
        INTENT_KEY,
        JSON.stringify({ slug: slug, action: action || "follow", source: source || "artist_page" })
      );
    } catch (error) {}
  }

  function readIntent() {
    try {
      var parsed = JSON.parse(sessionStorage.getItem(INTENT_KEY) || "null");
      return parsed && parsed.slug ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  function clearIntent() {
    try {
      sessionStorage.removeItem(INTENT_KEY);
    } catch (error) {}
  }

  function goLogin(slug, source) {
    stashIntent(slug, "follow", source);
    window.location.href = loginUrl();
  }

  function isFollowing(slug) {
    slug = String(slug || "").trim().toLowerCase();
    return Boolean(state[slug] && state[slug].following);
  }

  function hydrate(slugs) {
    var list = [];
    if (Array.isArray(slugs) && slugs.length) {
      list = slugs;
    } else {
      document.querySelectorAll("[data-follow-artist]").forEach(function (btn) {
        var slug = (btn.getAttribute("data-follow-artist") || "").trim().toLowerCase();
        if (slug && list.indexOf(slug) === -1) list.push(slug);
      });
    }
    if (!list.length) return Promise.resolve(state);

    var cached = readCache();
    Object.keys(cached).forEach(function (slug) {
      if (!state[slug] && cached[slug]) state[slug] = cached[slug];
    });
    list.forEach(paint);

    return request("/follow-state?slugs=" + encodeURIComponent(list.join(","))).then(function (body) {
      if (body.status === 401 && body.error === "login_required") return state;
      if (!body.ok && body.status !== 200) return state;
      var next = {};
      list.forEach(function (slug) {
        if (body[slug]) next[slug] = body[slug];
      });
      mergeState(Object.keys(next).length ? next : body);
      list.forEach(paint);
      return state;
    }).catch(function () {
      return state;
    });
  }

  function toggle(slug, source) {
    slug = String(slug || "").trim().toLowerCase();
    source = source || "artist_page";
    if (!slug || pending[slug]) return Promise.resolve(state[slug]);

    if (!isLoggedIn()) {
      goLogin(slug, source);
      return Promise.resolve(state[slug]);
    }

    var current = state[slug] || { following: false, follower_count: 0, last_seen_at: null };
    var action = current.following ? "unfollow" : "follow";
    var snapshot = {
      following: current.following,
      follower_count: current.follower_count,
      last_seen_at: current.last_seen_at
    };
    var optimisticCount = snapshot.follower_count + (action === "follow" ? 1 : -1);
    if (optimisticCount < 0) optimisticCount = 0;

    pending[slug] = true;
    var optimistic = {};
    optimistic[slug] = {
      following: action === "follow",
      follower_count: optimisticCount,
      last_seen_at: snapshot.last_seen_at
    };
    mergeState(optimistic);
    paint(slug);

    return request("/follow", {
      method: "POST",
      headers: { accept: "application/json", "content-type": "application/json" },
      body: JSON.stringify({ artist_slug: slug, action: action, source: source })
    }).then(function (body) {
      pending[slug] = false;
      if (body.status === 401 && (body.error === "login_required" || body.error === "missing_signature")) {
        var reverted = {};
        reverted[slug] = snapshot;
        mergeState(reverted);
        paint(slug);
        goLogin(slug, source);
        return state[slug];
      }
      if (!body.ok) {
        var failed = {};
        failed[slug] = {
          following: snapshot.following,
          follower_count: snapshot.follower_count,
          last_seen_at: snapshot.last_seen_at,
          error: true
        };
        mergeState(failed);
        paint(slug);
        emit(slug, state[slug]);
        return state[slug];
      }
      var confirmed = {};
      confirmed[slug] = {
        following: Boolean(body.following),
        follower_count: Number(body.follower_count) || 0,
        last_seen_at: snapshot.last_seen_at
      };
      mergeState(confirmed);
      paint(slug);
      emit(slug, state[slug]);
      return state[slug];
    }).catch(function () {
      pending[slug] = false;
      var rolled = {};
      rolled[slug] = {
        following: snapshot.following,
        follower_count: snapshot.follower_count,
        last_seen_at: snapshot.last_seen_at,
        error: true
      };
      mergeState(rolled);
      paint(slug);
      emit(slug, state[slug]);
      return state[slug];
    });
  }

  function replayIntent() {
    var intent = readIntent();
    if (!intent || !isLoggedIn()) return;
    clearIntent();
    toggle(intent.slug, intent.source || "artist_page");
  }

  function on(event, fn) {
    if (event !== "change" || typeof fn !== "function") return function () {};
    listeners.push(fn);
    return function () {
      listeners = listeners.filter(function (item) {
        return item !== fn;
      });
    };
  }

  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-follow-artist]");
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(btn.getAttribute("data-follow-artist"), btn.getAttribute("data-follow-source") || "artist_page");
  });

  function boot() {
    var cached = readCache();
    Object.keys(cached).forEach(function (slug) {
      state[slug] = cached[slug];
    });
    hydrate().then(function () {
      replayIntent();
      document.dispatchEvent(new CustomEvent("theartfolio:followhydrate"));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.TheArtfolioFollow = {
    isFollowing: isFollowing,
    toggle: toggle,
    hydrate: hydrate,
    on: on
  };
})();
